<template>
  <div>
    <!-- 固定的标题区域 -->
    <div class="md:hidden phone_main_recruit_head">
      <div>全部职位</div>
      <el-divider />
    </div>

    <div class="small_screen">
      <div class="phone_main">
        <div class="phone_main_main">
          <div class="phone_main_recruit">
            <div class="phone_main_recruit_main">
              <div class="recruit_table_main">
                <div v-for="(data, index) in tableData" :key="data.n" class="recruit_table_main_item" @click="show(index)">
                  <div class="recruit_table_main_item_left">
                    <div class="recruit_table_main_item_left_name">{{ data.n }}</div>
                    <div class="recruit_table_main_item_left_addr">{{ data.a }}</div>
                  </div>
                  <div class="recruit_table_main_item_right">
                    查看
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <el-drawer
        title="职位详情"
        :visible.sync="drawers.drawer"
        :direction="drawers.d"
        :modal="drawers.m"
        :size="drawers.size"
        class="text_center recruit_info_drawer"
      >
        <el-scrollbar style="height: calc(100vh - 70px)">
          <div class="recruit_info_drawer_main">
            <div class="text_left recruit_info">
              <div class="info_head">职位内容：</div>
              <template v-for="(d, i) in drawers.info.wc">
                <div :key="i">
                  <span>{{ (++i) + '、' }}</span>
                  <span>{{ d }}</span>
                </div>
              </template>
            </div>
            <div class="text_left recruit_info">
              <div class="info_head" style="margin-top: 30px">职位需求：</div>
              <template v-for="(d, i) in drawers.info.wr">
                <div :key="i">
                  <span>{{ (++i) + '、' }}</span>
                  <span>{{ d }}</span>
                </div>
              </template>
            </div>
            <div class="send text_left recruit_info">
              <el-button type="primary" @click="dialogVisible = true">投递简历</el-button>
            </div>
          </div>
        </el-scrollbar>
      </el-drawer>

      <el-dialog :visible.sync="dialogVisible" :modal="false" width="70%">
        <div class="phone_recruit_dialog">
          <div class="dialog_mail_icon"><i class="el-icon-message" style="font-size: 72px" /></div>
          <div class="dialog_font">
            <p style="font-weight: bold">请将简历及作品发送至:</p>
            <p>{{ recruitMail }}</p>
            <p style="font-weight: bold;margin-top: 10px">邮件主题为:</p>
            <p>地点+职位+姓名</p>
          </div>
          <div class="dialog_button">
            <el-button style="margin-top: 10px" type="primary" @click="dialogVisible = false">确 定</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { get_recruit_data_page, get_recruit_info } from '@/api/recruit'
import vv from '@/components/varVariable'

const all = '全部'
export default {
  name: 'PhoneRecruit',
  data: function() {
    return {
      // 手机版招聘
      select: {
        id: '',
        like: '',
        addr: '',
        type: '',
        pageSize: 8,
        pageNum: 1,
        total: 0,
        totalPage: 1
      },
      addr: [],
      type: [],
      tableData: [],
      drawers: {
        drawer: false,
        d: 'rtl',
        m: false,
        size: '80%',
        info: {},
        phone: {
          drawer: false,
          d: 'rtl'
        }
      },
      dialogVisible: false,
      recruitMail: '8888888888@qq.com',
      recruitImgs: [
        '/nemojoyWebSiteFile/imgs/recruit/1.png',
        '/nemojoyWebSiteFile/imgs/recruit/2.png',
        '/nemojoyWebSiteFile/imgs/recruit/3.png',
        '/nemojoyWebSiteFile/imgs/recruit/4.png',
        '/nemojoyWebSiteFile/imgs/recruit/5.png',
        '/nemojoyWebSiteFile/imgs/recruit/6.png'
      ]
    }
  },
  computed: {
    filePath() {
      return vv.fileHttp
    }
  },
  created() {
    this.selectRecruit()
    this.getRecruitInfo()
  },
  methods: {
    selectRecruit() {
      get_recruit_data_page(this.select)
        .then(d => {
          const data = d.d
          if (data) {
            const l = data.length
            this.tableData.length = l
            for (let i = 0; i < l; i++) {
              this.tableData.splice(i, 1, data[i])
            }
            this.select.totalPage = d.totalPage
            this.select.total = d.totalNum
            this.select.pageSize = d.pageSize
            this.select.pageNum = d.pageNum
          }
        })
    },
    getRecruitInfo() {
      get_recruit_info()
        .then(d => {
          if (!d) {
            return
          }
          const da = d.a
          if (d.a) {
            const l = da.length
            this.addr.length = l
            for (let i = 0; i < l; i++) {
              this.addr.splice(i, 1, da[i])
            }
            this.addr.splice(0, 0, all)
          }

          const dt = d.t
          if (dt) {
            const lt = dt.length
            this.type.length = lt
            for (let i = 0; i < lt; i++) {
              this.type.splice(i, 1, dt[i])
            }
            this.type.splice(0, 0, all)
          }

          this.recruitMail = d.e
        })
    },
    show(index) {
      this.drawers.drawer = true
      this.drawers.info = this.tableData[index]
    }
  }
}
</script>

<style lang="scss">
.phone_main_recruit_head {
  position: fixed;
  top: 3rem;
  left: 0;
  right: 0;
  z-index: 40;
  background: #ffffff;
  padding: 15px 20px;
  text-align: center;

  div {
    color: #7B2CBF;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 8px;
  }

  .el-divider {
    margin: 0;
  }
}

.small_screen {
  height: auto;
  color: #303133;

  .phone_main {
    margin-top: 8rem; /* 调整顶部距离，避免被固定标题遮挡 */

    .phone_main_main{
      padding: 0 20px 20px;

      .phone_main_recruit {
        max-height: calc(100vh - 90px);
        margin-bottom: 10px;

        .phone_main_recruit_main {
          .table_head {
            display: flex;
            flex-direction: column;
            justify-content: left;

            .table_head_select {
              padding-bottom: 10px;

              .head_title {
                width: 60px;
                display: inline-block;
              }

              .table_head_select_main {
                display: inline-block;

                .select_input {
                  width: 70%;
                  max-width: 200px;
                  margin-right: 10px;
                }
              }

              .tag {
                padding: 5px;
                border-radius: 5px;
                margin: 0 5px;
              }

              .tag:first-child {
                margin-left: 2px;
              }

              .selected {
                background-color: #CCCCCC;
              }
            }
          }

          .recruit_table_main {
            .recruit_table_main_item{
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 16px 25px;
              margin-bottom: 10px;
              border-radius: 5px;
              box-shadow: 0 3px 8px 0 rgb(0 0 0 / 10%);

              .recruit_table_main_item_left{
                font-size: 15px;

                .recruit_table_main_item_left_addr{
                  font-size: 13px;
                  color: #C0C4CC;
                }
              }

              .recruit_table_main_item_right{
                //color: #606266;
                font-size: 12px;
                padding: 3px 12px;
                border-radius: 5px;
                border: 1px solid #C0C4CC;
              }
            }
          }
        }
      }

      .phone_main_welfare{
        .phone_main_welfare_head{
          display: flex;
          justify-content: center;
        }

        .phone_main_welfare_img{
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;

          img {
            width: 30%;
            margin-bottom: 10px;
          }
        }
      }
    }
  }

  .recruit_info_drawer{
    .el-drawer__header{
      font-size: 15px;
      font-weight: bold;
      color: #303133;
      margin-bottom: 0;
    }

    .recruit_info_drawer_main{
      padding: 20px 20px 0;
      font-size: 14px;

      .info_head{
        font-size: 15px;
        font-weight: bold;
      }

      .send{
        margin-top: 10px;
      }
    }
  }

  .el-dialog__body{
    .phone_recruit_dialog{
      .dialog_mail_icon{
        display: flex;
        justify-content: center;
        margin-bottom: 10px;
      }

      .dialog_font{
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .dialog_button{
        display: flex;
        justify-content: center;
      }
    }
  }
}
</style>
